import { createFileRoute, redirect } from "@tanstack/react-router";

import { DEFAULT_LANGUAGE_CODE, LanguageCode } from "~/shared/i18n";
import { SLASH } from "~/shared/str";
import { isOneOf } from "~/shared/type-guard";

export const Route = createFileRoute("/{-$locale}")({
  beforeLoad: ({ params: { locale }, matches }) => {
    if (!isOneOf(locale, Object.values(LanguageCode))) {
      const routePath = matches.at(-1)?.fullPath;
      const homePath = "/{-$locale}";
      redirect({
        to: (isOneOf(routePath, [SLASH, "/{-$locale}/"]) ? homePath : routePath) ?? homePath,
        params: (prev) => ({
          ...prev,
          locale: DEFAULT_LANGUAGE_CODE,
        }),
        search: (prev) => prev,
        hash: true,
        state: true,
        throw: true,
      });
    }
  },
});
